import {
  CreateBookkeepersManagementTaskStatusDocument,
  CreateBookkeepersManagementTaskStatusMutation,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'

export default function useCreateTaskStatus() {
  const [createTaskStatusCall, { data, loading }] = useMutation(
    CreateBookkeepersManagementTaskStatusDocument,
    {
      extractorFn: (taskData: CreateBookkeepersManagementTaskStatusMutation) =>
        taskData.bookkeepersManagementMutations.createBookkeepersmanagementTaskTaskStatus,
    }
  )

  const createTaskStatus = async (completed: boolean, taskTypeId: string, incidenceId: string) => {
    const unhandledResult = await createTaskStatusCall({
      context: { isBookkeeperView: true },
      variables: {
        completed,
        taskTypeId,
        incidenceId,
      },
    })

    const result = handleResult(unhandledResult, () => undefined)

    if (!result.success) {
      return {
        error: true,
      } as const
    }

    return {
      data: result.data.taskStatus,
      error: false,
    } as const
  }

  const taskStatus =
    data?.bookkeepersManagementMutations.createBookkeepersmanagementTaskTaskStatus.taskStatus

  return {
    createTaskStatus,
    taskStatus,
    loading,
  }
}
